import { Component, OnInit, Signal } from '@angular/core';
import { Store } from '@ngrx/store';
import { loadCollection } from '../../../store/actions/surveys.actions';
import { selectLoading, selectPending, selectSurveyList } from '../../../store/selectors/surveys.selectors';
import { SurveyBaseAllBaseReadSurveyAllSurveyRead } from '../../../openapi';
import { ContentComponent } from '../../../components/content/content.component';
import { BreadcrumbsComponent } from '../../../common/breadcrumbs/breadcrumbs.component';
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../../../common/spinner/spinner.component';
import { FormsModule } from '@angular/forms';
import { AlertComponent } from '../../../common/alert/alert.component';
import { FilterDataPipe } from '../../../pipes/filter-data.pipe';
import { RouterLink } from '@angular/router';
import { LabelComponent } from '../../../common/label/label.component';

@Component({
  selector: 'app-surveys-list-page',
  standalone: true,
  imports: [
    ContentComponent,
    BreadcrumbsComponent,
    CommonModule,
    SpinnerComponent,
    FormsModule,
    AlertComponent,
    FilterDataPipe,
    RouterLink,
    LabelComponent
  ],
  templateUrl: './surveys-list-page.component.html'
})
export class SurveysListPageComponent implements OnInit {

  public filterValue: string = '';

  public surveys: Signal<SurveyBaseAllBaseReadSurveyAllSurveyRead[]> = this.store$.selectSignal(selectSurveyList);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  public pending: Signal<boolean> = this.store$.selectSignal(selectPending);

  public successMessage = history.state?.successMessage;

  constructor(
    private store$: Store
  ) {
  }

  public ngOnInit(): void {
    this.store$.dispatch(loadCollection());
  }
}
